<template>
    <div class="smart-table ajax">
        <div class="row btn-filter" v-if="!t.filter.disable">
            <div class="col">
                <button class="form-control btn btn-primary" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapseFilter_' + t.id" :aria-controls="'collapseFilter_' + t.id" aria-expanded="false">
                    <i class="pe-2 fa fa-filter" />Filtreleme
                </button>
            </div>
        </div>
        <div class="filter collapse" :id="'collapseFilter_' + t.id" v-if="!t.filter.disable">
            <div class="row g-2 align-items-end">
                <div :class="[t.fullFilter ? 'col-lg-12' : 'col-lg-6']" class="col-md-12 align-items-start">
                    <div class="row g-2">
                        <slot name="left"></slot>
                    </div>
                </div>
                <div :class="[t.fullFilter ? 'col-lg-12' : 'col-lg-6']" class="col-md-12 align-items-end">
                    <div class="row g-2 justify-content-end">
                        <div class="col-12 col-lg-auto" v-if="!t.filter.pagingSelectDisable">
                            <div class="paging-select">
                                <!--<label class="form-control-label fs-small-4">Sayfalama</label>-->
                                <select class="form-select" @change="changePagingSelect">
                                    <option :value="r" v-for="r in t.filter.pagingList" :key="r" :selected="r == t.filter.pagingSelect">{{ r == -1 ? "Tümü" : r }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6 col-lg-auto" v-if="!t.filter.searchDisable">
                            <div class="search">
                                <!--<label class="form-control-label fs-small-4">İçerik Arama</label>-->
                                <input :value="t.filter.search" @keyup.enter="changeSearch" type="search" class="form-control" placeholder="Arama yapınız..." />
                            </div>
                        </div>
                        <slot name="right"></slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <perfect-scrollbar class="col-12 table-responsive">
                <div v-if="t.listType" :id="t.id" class="list">
                    <template v-for="(item, index) in table.list" :key="item">
                        <slot :r="item" :index="index"></slot>
                    </template>
                    <div class="no-records-found" v-if="totalCount() > 0 && rowsCount == 0">
                        <span>Görüntülenecek Kayıt Yok</span>
                    </div>
                    <div class="no-records-found" v-if="totalCount() == 0">
                        <span>Kayıt Bulunamadı</span>
                    </div>
                </div>
                <table v-else :id="t.id" class="table table-hover table-striped table-bordered" :style="{ 'min-width': t.width }">
                    <thead>
                        <tr>
                            <th v-for="c in visibleColumns" :key="c" :class="columnCss(c)" :style="{ width: c.width }" @click="sortColumn($event)">{{ c.text }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(item, index) in table.list" :key="item">
                            <slot :r="item" :index="index"></slot>
                        </template>
                        <tr class="no-records-found" v-if="totalCount() > 0 && rowsCount == 0">
                            <td :colspan="visibleColumns.length">Görüntülenecek Kayıt Yok</td>
                        </tr>
                        <tr class="no-records-found" v-if="totalCount() == 0">
                            <td :colspan="visibleColumns.length">Kayıt Bulunamadı</td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>
        </div>
        <div class="row" v-if="t.filter.pagingList.length > 0">
            <div class="col-sm-12 col-md-6">
                <div class="records-info" role="status" aria-live="polite">
                    <span>Görüntülenen: <span v-if="t.filter.pagingSelect >= 0">{{ (page.select - 1) * t.filter.pagingSelect + 1 }}-{{page.select * t.filter.pagingSelect > totalCount() ? totalCount() : page.select * t.filter.pagingSelect}}</span><span v-else>1-1</span></span>
                    <!--<span>Görüntülenen: {{ (page.select - 1) * t.filter.pagingSelect + 1 }}-{{page.select * t.filter.pagingSelect > totalCount() ? totalCount() : page.select * t.filter.pagingSelect}}</span>-->
                    <span> | Toplam Kayıt: {{ totalCount() }}</span>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <nav aria-label="navigation">
                    <ul class="pagination justify-content-end">
                        <li class="page-item first" :class="{ disabled: page.select == 1 }">
                            <a href="javascript:void(0);" class="page-link" @click="page.select = 1;changePage();">
                                <span aria-hidden="true">&laquo;&laquo;</span>
                            </a>
                        </li>
                        <li class="page-item previous" :class="{ disabled: page.select == 1 }">
                            <a href="javascript:void(0);" class="page-link" @click="page.select -= 1;changePage();">
                                <span aria-hidden="true">&laquo;</span>
                            </a>
                        </li>
                        <li class="page-item">
                            <input type="number" min="1" :max="page.count" v-model="page.select" @change="changePage();" /><span>/ {{ page.count }}</span>
                        </li>
                        <li class="page-item next" :class="{ disabled: page.select == page.count }">
                            <a href="javascript:void(0);" class="page-link" @click="page.select += 1;changePage();">
                                <span aria-hidden="true">&raquo;</span>
                            </a>
                        </li>
                        <li class="page-item last" :class="{ disabled: page.select == page.count }">
                            <a href="javascript:void(0);" class="page-link" @click="page.select = page.count;changePage();">
                                <span aria-hidden="true">&raquo;&raquo;</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>
<script>
    import { appData, C, Rnd, Text } from "@/helpers/global";

    import { PerfectScrollbar } from "vue3-perfect-scrollbar";

    export default {
        name: "AjaxSmartTable",
        init(j) {
            j.id = Rnd.Id(25);
            if (!j.filter) {
                j.filter = {};
            }
            if (j.filter.disable === undefined) {
                j.filter.disable = false;
            }
            if (j.filter.searchDisable === undefined) {
                j.filter.searchDisable = false;
            }
            if (j.filter.pagingSelectDisable === undefined) {
                j.filter.pagingSelectDisable = false;
            }
            if (!j.filter.search) {
                j.filter.search = "";
            }
            if (!j.filter.pageIndex) {
                j.filter.pageIndex = 0;
            }
            if (!j.filter.recordCount) {
                j.filter.recordCount = 0;
            }
            if (!j.filter.pagingList) {
                j.filter.pagingList = [10, 25, 50, 100];
            }
            if (!j.filter.pagingSelect) {
                j.filter.pagingSelect = 0;
            }
            if (!j.width) {
                j.width = "768px";
            }
            if (!j.columns) {
                j.columns = [];
            }
            if (!j.totalCount) {
                j.totalCount = 0;
            }
            if (!j.list) {
                j.list = [];
            }
            if (!j.fullFilter) {
                j.fullFilter = false;
            }
            if (!j.listType) {
                j.listType = false;
            }
            return j;
        },
        components: {
            PerfectScrollbar,
        },
        props: {
            table: {
                type: Object,
            },
        },
        emits: ["count", "changeSearch", "changeSort", "changePage"],
        watch: {
            table: {
                handler() {
                    if (this.page.select != this.t.filter.pageIndex + 1) {
                        this.page.select = this.t.filter.pageIndex + 1;
                    }
                    this.load();
                },
                deep: true,
            },
        },
        data() {
            return {
                t: this.table,
                sortIndex: -1,
                sortAZ: false,
                page: {
                    select: 1,
                    count: 1,
                },
                reInit: false,
            };
        },
        methods: {
            load() {
                const _this = this;
                if (this.t.list == null) {
                    this.t.list = [];
                }
                if (this.reInit) {                    
                    if (C.Int(this.t.filter.pagingSelect) == 0) {
                        if (this.t.filter.pagingList.length > 0) {
                            let x = C.Int(this.totalCount() / this.t.filter.pagingList[0]);
                            for (let i = this.t.filter.pagingList.length - 1; i >= 0; i--) {
                                if (x >= this.t.filter.pagingList[i]) {
                                    this.t.filter.pagingSelect = this.t.filter.pagingList[i];
                                    break;
                                }
                            }
                            if (x < this.t.filter.pagingList[0]) {
                                this.t.filter.pagingSelect = this.t.filter.pagingList[0];
                            }
                        }
                        else {
                            this.t.filter.pagingSelect = 0;
                        }
                    }
                }
                this.reInit = false;
                this.$emit("count", this.totalCount());
                let cList = this.visibleColumns;
                this.pagingData();

                this.$nextTick(() => {
                    let table = document.getElementById(_this.t.id);
                    if (table) {
                        let trList = table.querySelectorAll('tbody tr:not(.no-records-found):not(.child)');
                        appData.fn.each(trList, function () {
                            appData.fn.each(this.querySelectorAll('td b.th'), function () {
                                this.remove();
                            });
                            let tdList = this.querySelectorAll('td');
                            appData.fn.each(tdList, function (index) {
                                if (!this.classList.contains('no-title')) {
                                    let b = document.createElement("b");
                                    b.innerText = cList[index] ? cList[index].text : "";
                                    b.classList.add('th');
                                    if (this.firstChild) {
                                        this.firstChild.before(b);
                                    }
                                    else {
                                        this.append(b);
                                    }
                                }
                            });
                        });
                    }
                });

            },
            totalCount() {
                return this.t.totalCount;
            },
            columnCss(c) {
                let l = [];
                if (c.css) {
                    if (c.css != "") {
                        l = C.Str(c.css).split(",");
                    }
                }
                if (!C.Bool(c.sort, true)) {
                    l.push("no-sort");
                }
                if (!C.Bool(c.export, true)) {
                    l.push("no-export");
                }
                return l;
            },
            pagingData() {
                try {
                    if (this.t.filter.pagingList.length > 0) {
                        this.page.count = C.Int(this.totalCount() / this.t.filter.pagingSelect) + (this.totalCount() % this.t.filter.pagingSelect > 0 ? 1 : 0);

                        if (this.page.count <= 0) {
                            this.page.count = 1;
                        }
                        if (this.page.select <= 0) {
                            this.page.select = 1;
                            return true;
                        }
                        if (this.page.select > this.page.count) {
                            this.page.select = this.page.count;
                            return true;
                        }
                    }
                    else {
                        // Sayfalama yok!
                        this.page.count = 1;
                        this.page.select = 1;
                    }
                } catch (ex) {
                    console.error("Paging Error:" + ex.message);
                }
                return false;
            },
            sortColumn(event) {
                let sender = event.target;
                if (sender) {
                    try {
                        if (sender.classList.contains("no-sort")) {
                            sender.classList.remove("sort-up");
                            sender.classList.remove("sort-down");
                        }
                        else {
                            let status = false;
                            if (sender.classList.contains("sort-down")) {
                                status = true;
                            } // A-Z
                            else if (sender.classList.contains("sort-up")) {
                                status = false;
                            } // Z-A
                            else {
                                status = false;
                            }
                            status = !status;
                            appData.fn.each(
                                sender.closest("tr").querySelectorAll("th"),
                                function () {
                                    this.classList.remove("sort-up");
                                    this.classList.remove("sort-down");
                                }
                            );
                            sender.classList.add(status ? "sort-down" : "sort-up");
                            this.sortIndex = sender.cellIndex;
                            this.sortAZ = status;
                            //Sıralama Yap
                        }

                        let l = this.table.list;
                        if (this.totalCount() > 0 && this.sortIndex > -1 && this.sortIndex < this.t.columns.length) {
                            let c = this.t.columns[this.sortIndex];
                            if (c.type == null) {
                                if (typeof l[0][c.name] === "number") {
                                    c.type = "dec";
                                }
                                if (typeof l[0][c.name] === "object") {
                                    if (!isNaN(l[0][c.name])) {
                                        if (Object.prototype.toString.call(l[0][c.name]) === "[object Date]") {
                                            c.type = "datetime";
                                        }
                                    }
                                }
                            }
                            this.$emit("changeSort", { name: c.name, type: c.type, sortAZ: this.sortAZ, index: this.sortIndex });
                            //this.$emit("changeSort", { name: c.name + '-' + (this.sortAZ ? 'A' : 'Z'), index: this.sortIndex });
                        }
                    } catch (ex) {
                        console.error("Sort Error:" + ex.message);
                    }
                }
            },
            changeSearch(event) {
                if (this.t.filter.search != event.target.value) {
                    this.t.filter.search = event.target.value;
                    this.$emit("changeSearch", this.t.filter.search);
                }
            },
            changePage() {
                if (!this.pagingData()) {
                    this.t.filter.pageIndex = this.page.select - 1;
                    this.$emit("changePage", { pageIndex: this.t.filter.pageIndex, pageSize: this.t.filter.pagingSelect });
                }
            },
            changePagingSelect(event) {
                this.reInit = false;
                this.t.filter.pagingSelect = C.Int(event.target.value);
                if (!this.pagingData()) {
                    this.t.filter.pageIndex = this.page.select - 1;
                    this.$emit("changePage", { pageIndex: this.t.filter.pageIndex, pageSize: this.t.filter.pagingSelect });
                }
            },
        },
        computed: {
            visibleColumns() {
                let l = [];
                for (let i = 0; i < this.t.columns.length; i++) {
                    if (!C.Bool(this.t.columns[i].hide)) {
                        l.push(this.t.columns[i]);
                    }
                }
                return l;
            },
            rowsCount() {
                return this.table.list.length;
            }
        },
        created() {
            this.reInit = true;
            this.load();
        },
    };
</script>
